import { NgModule } from '@angular/core';

// Roteamento
import { PeticaoRoutingModule } from './peticao.routing';

// Guardas
// import { AuthGuard } from '@app/guards/auth.guard';

// Módulos
import { SharedModule } from '@app/shared/shared.module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ClipboardModule } from 'ngx-clipboard';

// Componentes
import { PeticaoListaComponent } from '@app/pages/peticao/peticao/peticao-lista/peticao-lista.component';
import { PeticaoFormComponent } from '@app/pages/peticao/peticao/peticao-form/peticao-form.component';
import { PeticaoAreasFormComponent } from '@app/pages/peticao/peticao-areas/peticao-areas-form/peticao-areas-form.component';
import { PeticaoAreasListaComponent } from '@app/pages/peticao/peticao-areas/peticao-areas-lista/peticao-areas-lista.component';
import { PeticaoTeseFormComponent } from '@app/pages/peticao/peticao-tese/peticao-tese-form/peticao-tese-form.component';
import { PeticaoTeseListaComponent } from '@app/pages/peticao/peticao-tese/peticao-tese-lista/peticao-tese-lista.component';

// Services
import { PeticaoService } from '@app/services/peticao.service';
import { PeticaoTeseService } from '@app/services/peticao-tese.service';
import { PeticaoAreaService } from '@app/services/peticao-area.service';
import { ConsultasService } from '@app/services/consultas.service';
import { UtilitarioService } from '@app/services/utilitario.service';

@NgModule({
  declarations: [
    PeticaoListaComponent,
    PeticaoFormComponent,
    PeticaoAreasFormComponent,
    PeticaoAreasListaComponent,
    PeticaoTeseFormComponent,
    PeticaoTeseListaComponent,
  ],
  imports: [
    PeticaoRoutingModule,
    SharedModule,
    ClipboardModule,
    TabsModule.forRoot(),
  ],
  providers: [
    // AuthGuard,
    PeticaoService,
    PeticaoTeseService,
    PeticaoAreaService,
    ConsultasService,
    UtilitarioService,
  ]
})
export class PeticaoModule { }
